import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "./FotoDivisi.scss";


// IMPORT COMPONENTS
import TopInfo from "../../Components/TopInfo/TopInfo";
import HeadingLogo from "../../Components/HeadingLogo/HeadingLogo";

import logo from "../../Assets/FotoDivisi/wiskira/LogoSwiper.png";
import kupu from "../../Assets/FotoDivisi/wiskira/KupuKupu.svg";
import supergrafis from "../../Assets/FotoDivisi/wiskira/KupuKupu.svg";

// Import untuk listFotoSwiper
import arsaSwiper1A from "../../Assets/FotoDivisi/arsa/Swiper1A.jpg";
import arsaSwiper1B from "../../Assets/FotoDivisi/arsa/Swiper1B.jpg";
import arsaSwiper2A from "../../Assets/FotoDivisi/arsa/Swiper2A.jpg";
import arsaSwiper2B from "../../Assets/FotoDivisi/arsa/Swiper2B.jpg";
import arsaSwiper3A from "../../Assets/FotoDivisi/arsa/Swiper3A.jpg";
import arsaSwiper3B from "../../Assets/FotoDivisi/arsa/Swiper3B.jpg";
import arsaSwiper4A from "../../Assets/FotoDivisi/arsa/Swiper4A.jpg";
import arsaSwiper4B from "../../Assets/FotoDivisi/arsa/Swiper4B.jpg";
import arsaSwiper5A from "../../Assets/FotoDivisi/arsa/Swiper5A.jpg";
import arsaSwiper5B from "../../Assets/FotoDivisi/arsa/Swiper5B.jpg";
import arsaSwiper6A from "../../Assets/FotoDivisi/arsa/Swiper6A.jpg";
import arsaSwiper6B from "../../Assets/FotoDivisi/arsa/Swiper6B.jpg";
import arsaSwiper7A from "../../Assets/FotoDivisi/arsa/Swiper7A.jpg";
import arsaSwiper7B from "../../Assets/FotoDivisi/arsa/Swiper7B.jpg";

import adhyastaSwiper1A from "../../Assets/FotoDivisi/adhyasta/Swiper1A.jpg";
import adhyastaSwiper1B from "../../Assets/FotoDivisi/adhyasta/Swiper1B.jpg";
import adhyastaSwiper2A from "../../Assets/FotoDivisi/adhyasta/Swiper2A.jpg";
import adhyastaSwiper2B from "../../Assets/FotoDivisi/adhyasta/Swiper2B.jpg";
import adhyastaSwiper3A from "../../Assets/FotoDivisi/adhyasta/Swiper3A.jpg";
import adhyastaSwiper3B from "../../Assets/FotoDivisi/adhyasta/Swiper3B.jpg";

import sarwagaSwiper1A from "../../Assets/FotoDivisi/sarwaga/Swiper1A.jpg";
import sarwagaSwiper1B from "../../Assets/FotoDivisi/sarwaga/Swiper1B.jpg";
import sarwagaSwiper2A from "../../Assets/FotoDivisi/sarwaga/Swiper2A.jpg";
import sarwagaSwiper2B from "../../Assets/FotoDivisi/sarwaga/Swiper2B.jpg";

// Import untuk listAnggotaWiskira
import wiskiraAnggota1A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota1A.png";
import wiskiraAnggota1B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota1B.png";
import wiskiraAnggota2A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota2A.png";
import wiskiraAnggota2B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota2B.png";
import wiskiraAnggota3A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota3A.png";
import wiskiraAnggota3B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota3B.png";
import wiskiraAnggota4A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota4A.png";
import wiskiraAnggota4B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota4B.png";
import wiskiraAnggota5A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota5A.png";
import wiskiraAnggota5B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota5B.png";
import wiskiraAnggota6A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota6A.png";
import wiskiraAnggota6B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota6B.png";
import wiskiraAnggota7A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota7A.png";
import wiskiraAnggota7B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota7B.png";
import wiskiraAnggota8A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota8A.png";
import wiskiraAnggota8B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota8B.png";
import wiskiraAnggota9A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota9A.png";
import wiskiraAnggota9B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota9B.png";
import wiskiraAnggota10A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota10A.png";
import wiskiraAnggota10B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota10B.png";
import wiskiraAnggota11A from "../../Assets/FotoDivisi/wiskira/SwiperAnggota11A.png";
import wiskiraAnggota11B from "../../Assets/FotoDivisi/wiskira/SwiperAnggota11B.png";

// Import untuk listAnggotaPrabangkara
import prabangkaraAnggota1A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota1A.png";
import prabangkaraAnggota1B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota1B.png";
import prabangkaraAnggota2A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota2A.png";
import prabangkaraAnggota2B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota2B.png";
import prabangkaraAnggota3A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota3A.png";
import prabangkaraAnggota3B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota3B.png";
import prabangkaraAnggota4A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota4A.png";
import prabangkaraAnggota4B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota4B.png";
import prabangkaraAnggota5A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota5A.png";
import prabangkaraAnggota5B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota5B.png";
import prabangkaraAnggota6A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota6A.png";
import prabangkaraAnggota6B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota6B.png";
import prabangkaraAnggota7A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota7A.png";
import prabangkaraAnggota7B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota7B.png";
import prabangkaraAnggota8A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota8A.png";
import prabangkaraAnggota8B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota8B.png";
import prabangkaraAnggota9A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota9A.png";
import prabangkaraAnggota9B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota9B.png";
import prabangkaraAnggota10A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota10A.png";
import prabangkaraAnggota10B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota10B.png";
import prabangkaraAnggota11A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota11A.png";
import prabangkaraAnggota11B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota11B.png";
import prabangkaraAnggota12A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota12A.png";
import prabangkaraAnggota12B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota12B.png";
import prabangkaraAnggota13A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota13A.png";
import prabangkaraAnggota13B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota13B.png";
import prabangkaraAnggota14A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota14A.png";
import prabangkaraAnggota14B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota14B.png";
import prabangkaraAnggota15A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota15A.png";
import prabangkaraAnggota15B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota15B.png";
import prabangkaraAnggota16A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota16A.png";
import prabangkaraAnggota16B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota16B.png";
import prabangkaraAnggota17A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota17A.png";
import prabangkaraAnggota17B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota17B.png";
import prabangkaraAnggota18A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota18A.png";
import prabangkaraAnggota18B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota18B.png";
import prabangkaraAnggota19A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota19A.png";
import prabangkaraAnggota19B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota19B.png";
import prabangkaraAnggota20A from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota20A.png";
import prabangkaraAnggota20B from "../../Assets/FotoDivisi/prabangkara/SwiperAnggota20B.png";

const semuaAsetDivisi = require.context("../../Assets/FotoDivisi", true, /\.(mp3|webp|jpg|jpeg)$/);

const dapatkanAset = (pathRelatif) => {
    try {
        return semuaAsetDivisi(`./${pathRelatif}`);
    } catch (err) {
        console.error("Aset tidak ditemukan:", pathRelatif, err);
        return "";
    }
};


const FotoDivisi = () => {
    const path = window.location.pathname;
    const [domain, setDomain] = useState();
    const [slide, setSlide] = useState(0);
    const [foto, setFoto] = useState(null);

    const prevButton = useRef(null);
    const nextButton = useRef(null);
    const prevButtonRow = useRef(null);
    const nextButtonRow = useRef(null);

    const nextSlide = () => {
        setSlide(slide + 1);
    };

    const prevSlide = () => {
        setSlide(slide - 1);
    };

    function openModal(props) {
        setModal(!modal);
        setFoto(props);
    }
    
    const FontNormal = {
        fontStyle: 'normal',
    };
    const FontItalic = {
        fontStyle: 'italic',
    };

    useEffect(() => {
        setDomain(path.substring(8));
    }, []);

    useEffect(() => {
        if(domain == "arsa") {
            if(slide == 7) {
                setSlide(0);
            }
            else if(slide == -1) {
                setSlide(6);
            }
        }
        else if(domain == "adhyasta") {
            if(slide == 3) {
                setSlide(0);
            }
            else if(slide == -1) {
                setSlide(2);
            }
        }
        else if(domain == "sarwaga") {
            if(slide == 2) {
                setSlide(0);
            }
            else if(slide == -1) {
                setSlide(1);
            }
        }
    }, [slide]);

    // MODAL
    const [modal, setModal] = useState(false);

    const Modal = useRef(null);

    // HANLDE CLOSE MODAL
    useEffect(() => {
        const handleClickRemoveModal = (event) => {
            if (!modal == false) {
                if (Modal.current) {
                    setModal(false);
                }
            }
        };
        document.addEventListener("click", handleClickRemoveModal, true);
        return () => {
            document.removeEventListener("click", handleClickRemoveModal, true);
        };
    }, [modal]);

    const listDivisi = [
        {
            "divisi": "bimantara",
            "nama": "BIMANTARA",
            "job": "Badan Pengurus Harian (BPH)",
            "style": FontNormal,
        },
        {
            "divisi": "kampana",
            "nama": "KAMPANA",
            "job": "Acara",
            "style": FontNormal,
        },
        {
            "divisi": "arsa",
            "nama": "ARSA",
            "job": "Person In Charge (PIC)",
            "style": FontItalic,
        },
        {
            "divisi": "adhyasta",
            "nama": "ADHYASTA",
            "job": "Keamanan",
            "style": FontNormal,
        },
        {
            "divisi": "syandana",
            "nama": "SYANDANA",
            "job": "Public Relation & Design",
            "style": FontItalic,
        },
        {
            "divisi": "sambara",
            "nama": "SAMBARA",
            "job": "Perlengkapan",
            "style": FontNormal,
        },
        {
            "divisi": "dayaka",
            "nama": "DAYAKA",
            "job": "Konsumsi",
            "style": FontNormal,
        },
        {
            "divisi": "sarwaga",
            "nama": "SARWAGA",
            "job": "Medis",
            "style": FontNormal,
        },
        {
            "divisi": "prabangkara",
            "nama": "PRABANGKARA",
            "job": "Dokumentasi",
            "style": FontNormal,
        },
        {
            "divisi": "wiskira",
            "nama": "WISKIRA",
            "job": "Website",
            "style": FontItalic,
        },
    ]

    const listAnggota = [
        {
            "divisi": "kampana",
            "koor": "Marcelino Ryan Surya, Wilcoustine Qhristmas Pniel, Yemima Willona Aristo",
            "anggota": "Aveline Jantika, Chatarina Ivanka, Gloria Wijaya, Kenny Adam, Lavia Jovelin, Rachel Natallie, Rahmat Kurniawan, Samuel Gerald David, Stefanny Chandra, Vania Putri Keisa",
            "color": "#B8110D",
            "lightColor": "rgba(184, 17, 13, 0.10)",
        },
        {
            "divisi": "syandana",
            "koor": "Charina Elliani, Clarissa Liani Ng, Delicia Karen Gunawan",
            "anggota": "Caroline Lorenza, Diwanti Divi Afrilia, Ferdinand Julius, Gabrielle Claudia Harto Wibowo, Jehezkiel Immanuel, Jessica Chandra, Muhammad Afiq Walid, Rara Anggreni, Ramadava Ardiyanto, Silvia Andriyani",
            "color": "#4D4D4D",
            "lightColor": "rgba(77, 77, 77, 0.10)",
        },
        {
            "divisi": "sambara",
            "koor": "Dhaniel Priambodo, Hellen Herlina, Mahdi Husein Punca",
            "anggota": "Airin Livia, Aurellia Ramli, Benedetto Kennard Wijaya, Christoper John Aranda, Cianando Pautrisio Cendranadi, Eunique Jovie, Iman Rhesa Reyhan Amantiya, Indah Desri Wahyuni, Khesar Kurniawan, Kristoforus Kharis Putra Sadsuitubun, Maria Cahaya Amornanta Wirastu, Michael Lucius Wijaya, Nurjihaan, Rafi Rabbani, Raqqat Amarasangga Iswahyudi, Reyhan Phillies Wijaya, Reynard, Vincent Marlino",
            "color": "#9300D2",
            "lightColor": "rgba(147, 0, 210, 0.10)",
        },
        {
            "divisi": "dayaka",
            "koor": "Jessica Chandra, Steven Natanael Hermanto",
            "anggota": "Alexander Daniel Cahyadi Mogo, Angeline Ageina Susanto, Assyifa Salsabila Hasibuan, Cherry Wijaya, Debora Priscilla Natalia, Delvin Hendro, Gisela Florentina, Jeannie Rukmana, Kleofas, Malvin Wijaya, Maria Jessica Eunike Dahayu, Michelle Liu, Murni Eunike Hutapea, Nasya Karina Wahyudin, Nathania Putri Qhen, Shyerly Shaferya, Yoshella Yuliana",
            "color": "#CBA78B",
            "lightColor": "rgba(203, 167, 139, 0.10)",
        },
        {
            "divisi": "sarwaga",
            "koor": "Jones Samuel Justine, Novia Ramadina Setiawati",
            "anggota": "Albert Amadio Trenedy, Andrew Jaya Susilo, Angelima Khosina, Angellica Kristie Lin, Arnela Setianegara, Audy Hendry, Chandra Wihaya Fatah, Cynthia Clara Santy, Daniel Himawan, Feodora Audrey Clementine, Fiorenza Irene Christabelle, Fransisko Krisdian Tara, Geraldi, Gisselle Angelina Tanuwidjaja, Jessica Eunice Sihasale, Jessica Sharon Maria Tampi, Kathryn Cahyadi, Keiko Rosario Chrisabel, Keira Norelia Chandra, Laticia Kimberly Tanto, Leonardus Efendi, Lina, Maureen Audilia, Michel Fransiska, Mishel Milen, Mohamad Syafriza Ramadhan, Naila Arshiya Hendriana, Najwa Khairunisa, Nabilah Syafira Ramadhani, Narita Changi, Nicholas Candra, Novan Gustaf Firyan, Parwinderjeet Singh, Patresia Lisnayanti Zalukhu, Richard Bona Tua Tindaon, Rio Leonardi, Roger Noel Austin Lee, Ryu Ivan Wijaya, Samuel Fernandtio, Syahlarichanda Salsabila, Vania Lay, Velery Yosafat Chia, Vianca Vanesia Barhan, Vivian Kristin Chiputri, Wiewyn",
            "color": "#41A76A",
            "lightColor": "rgba(65, 167, 106, 0.10)",
        },

    ]

    const listAnggotaRow = [
        {
            "divisi": "arsa",
            "koor": "Christopher Richard Gunawan, Clifford Aaron Darmawan, Jocelin Nathania Ichwan, Valecia Monroe Thendy",
            "anggota": [
                { "nama": "Adestia Febrianti, Angel Lawrensia, Angeline Precillia, Arsio Viriya Muliyawan, Catherine Olivia, Christian Johan, Cindy, Fenny Dwi Adiwena, Gabriella Stevie Euodia Priyono, Gwendeline Gail Sutrisno, Jennifer Abigail, Jennefer Chandra, Jessica Marella, Kelly Christian Hariyono, Marcel Jonathan, Nicholas Suwandi Wijaya, Petris Glaudya Liuwanda, Shafiragiovani Marvella, Sion Alexander Hartono, Stefani Margaretha Christie, Vinson, Yahaziel Yehuda Prastyoadi" },
                { "nama": "Alice Marybeth, Aulia Syifa Arthamevi, Audrey Gracia Chandra, Brightly Virya, Cornelia Alyssa Candra, Daniel Cahya Putra, Edwin Fedora Lolo, Hendricus Wibisono, Hotmauli Kristiani Siboro, Jessica, Jovita Angelina Mettasari, Marvell Christofer, Maria Rumbhaney Tarigan, Mawidah Muthia Fitriani, Natalia Christy, Regina Marcheliza, Sharone Angelica Jovans, Sheren Olivia, Siti Muthia Khadijah, Stefanie Jaya Susilo, Sunarto Wijaksono, Vidy Tandiono" },
                { "nama": "Aureen Trevisia Sutarna, Arifandi Wirawan, Brigitta Julia Sinaulan, Devin Tarangga, Felicia Aurell Thiopillia, Glen Owen, Jocelyn Janice, Laurentinus Heriyanto Setiadi, Martin, Melody Dennise Allegra, Michelle Gracya atmaja, Mitawati, Nadhira Keisya Callista, Nicholas Prawira Tanoto, Prisilia Laybertha, Priscillia Lindsey Setiadie, Rachel Azalia Hariwijaya, Rizky Ali Zamzami, Tanzania Febriana, Vanessa Olivia, Vania Ardelia" },
                { "nama": "Agym Dimas Tian, Angelina Yang, Azalea Keisha Putri, Calista Nathalia, Christy Angela Limardi, Clarissa Elvira Darmawan, Erva Yanti Daneuis, Felicia Jennifer, Ferbie Viona, Grisella Vevilia Lauren, Jennifer Landau, Kellysia Mona Andika, Marcia Septiani, Matthew Chang, Melinda Ariyana Dharmanto, Melissa Gracia, Michelle Williams, Nicholas Carlos Ricardo, Rachel Dayana Telaumbanua, Ray Anthony Pranoto, Ryan Ferdinand Andyson, Tamara Catalina Suwandi" },
                { "nama": "Andaru Hymawan Primayudha, Andi Bintang Rihhadatul Aisy, Anastasya Audrey Tengko, Andrew Natanael Tjandra, Auresia Yunita, Caesar Eka Nathanael, Callista Ariella Ginata, Chaterine Laurenthia, Cindy Aurellia Liwang, Christophorus Augusta Wangsa, Euderen Freyderik, Felix Rafael, Hafizah Balqis, Jacques Farrell Dharma, Jessie Valencia Tannuwijaya, Larissa Ika Kamila, Marchanda Guritna Halim, Melvin Tristan, Michelle Laurensia, Neisya Arsy Argya, Priscilla Agatha, Sinung Agung Cahyono" },
                { "nama": "Airyara Dorthea Warella, Brilliana Thalia Wijaya, Christina Elizabeth Kusumaluana, Cindy Theresa, Clarensia Anjeli, Crispus Adlai Anthony, Daffa Albiyananda, Diva Anggira Svasty, Dylan Liong Kusnowo, Francisco Anderson Gultom, Jason Timothy Sihite, Livinia Cathleen Gunawan, Margareta Averina Lianti, Patricia Febrina Maharani, Priscilla Karimang, Richard Sujono, Richard Tandean, Septhia Rosa Tambunan, Valencia Aurelia, Vallencia Natalie Bong, Vanessa, Vadreyna" },
                { "nama": "Alecia Cindy, Angriany Lutfiyah Darmawan, Benaya Arlyanto, Charlotte Yeung, Cindy Florencia, Dylan Ervian, Edmund, Florencia Eliana Imansjah, Ian Pangeswara Hermawan, Indira Sukma Dewi, Ivander Kristian Satya Putra, Jessie Yenca Vegustin, Muhammad Alifio Rachman, Rahmah Inayah, Ralph Theodoric Adam Zagoto, Reniati Noor Qomariany, Ruth Yushiana, Sean Marcello Talaar, Vallenzia Caroline, Verin Maria" },
            ],
            "color": "#FE7F9C",
            "lightColor": "rgba(253, 127, 155, 0.10)",
        },
        {
            "divisi": "adhyasta",
            "koor": "Ananda Ayu Putri, Jeremy Immanuel, Leideovico Yudhisti",
            "anggota": [
                { "nama": "Allison, Aurelio Bryan, Batara Hotdo, Deryan, Dean, Devon, Enselistiana, Evan Yo, Fellicia Virginia, Fransiska, Gamaliel Moshes, Haniva Yuniar,Jerry Januar, Jethro Jotham, Jonathan Bryan, Jolin Delicia, Karin Eldora, Laura, Marco, Marselino Lengyu, Martiza, Mikhail Lim, Natasya Zebua, Navsya Nitisara, Nino Pramudya, Patricia Millianty, Petrus, Tiaramitta, Valentino Fernando, Yosafat B Manik"},
                { "nama": "Aditya Stephen, Akbar, Angelica Michelle, Aurell Vienca, Celine Sugiaman, Daffa Taufik, Emilia Wiryawan, Ferdyan Hidayat, Hakam Natalegawa, Jennifer Severa, Jotys Rafly, Kezia Cheryl, Marcellino, Michelle Patricia, Muhammad Farhan, Paul Febrian, Sammy Ghoutan, William Purba, Whitney Serena, Yasmin Azzahra"},
                { "nama": "Agatha Sharon, Auralia Dwi, Caleb Steve, Carolus Cahyo, Cecilia Margaretha, Cecillia Abbygail, Dwiky Andika, Emanuel Bernandhika, Ersan Ivanda, Febianus Felix, Felicia Alexandra, Felix Angdinata, Gina Rohmatika, Joy Rockniel, Kerin Limitandy, Luthfansya Haikal, Melvie Ho, Muhammad Abidzar, Muhammad Baehaky, Muhammad Fathan N, Muhammad Farraszaky, Muhammad Luthfi Salinggih, Nafisah Cendekia, Patricia Tanjung, Qhedyzya, Royston Chiandra, Sayed Aqbil, Shahnaz Haliza, Silvi Dian, Teuku Fazariz"},
            ],
            "color": "#000",
            "lightColor": "rgba(0, 0, 0, 0.10)",
        },
        {
            "divisi": "sarwaga",
            "koor": "Jones Samuel Austin, Novia Ramadina Setiawati",
            "anggota": [
                { "nama": "Albelt Amadio Trenedy, Cynthia Clara Santy, Fransisko Krisdian Tara, Gisselle Angelina Tanuwidjaja, Jessica Eunice Sihasale, Jessica Sharon Maria Tampi, Kathryn Cahyadi, Keiko Rosario Chrisabel, Laticia Kimberly Tanto, Lina, Maureen Audilia, Michell Fransiska, Muhammad Syafriza R.S., Najwa Khairunnisa , Nabilah Syafira Ramadhani, Parwinderjeet Singh, Patresia Lisnayanti Zalukhu, Richard Bona Tuan Tindaon, Wiewyn Lioe, Yurcell Young, Zeta Milano" },
                { "nama": "Andrew Jaya Susilo, Angelima Khosina, Angellica Kristie Lien, Arnela Setianegara, Audy Hendry, Chandra Wijaya Fatah, Daniel Himawan, Feodora Audrey Clementine, Fiorenza Irene Christabelle Suryanto, Leonardus Efendi, Naila Arshiya Hendriana, Nicholas Chandra, Novan Gustaf Friyan, Rio Leornardi, Roger Noel Austin Lee, Ryu Ivan Wijayaa, Vania Lay, Velery Yosafat Chi, Vianca Vanesia Barhan, Vivian Kristin Chiputri, Syahla Richandra Salsabila, Geraldi, Keira Norelia, Mishel Milen, Narita Changi, Rifqah Aulia Salsabila, Samuel Fernandtio"},
            ],
            "color": "#40A86A",
            "lightColor": "rgba(120, 214, 159, 0.10)",
        },
    ]

    const listFotoSwiper = [
    { "divisi": "arsa", "foto1": arsaSwiper1A, "foto2": arsaSwiper1B },
    { "divisi": "arsa", "foto1": arsaSwiper2A, "foto2": arsaSwiper2B },
    { "divisi": "arsa", "foto1": arsaSwiper3A, "foto2": arsaSwiper3B },
    { "divisi": "arsa", "foto1": arsaSwiper4A, "foto2": arsaSwiper4B },
    { "divisi": "arsa", "foto1": arsaSwiper5A, "foto2": arsaSwiper5B },
    { "divisi": "arsa", "foto1": arsaSwiper6A, "foto2": arsaSwiper6B },
    { "divisi": "arsa", "foto1": arsaSwiper7A, "foto2": arsaSwiper7B },
    { "divisi": "adhyasta", "foto1": adhyastaSwiper1A, "foto2": adhyastaSwiper1B },
    { "divisi": "adhyasta", "foto1": adhyastaSwiper2A, "foto2": adhyastaSwiper2B },
    { "divisi": "adhyasta", "foto1": adhyastaSwiper3A, "foto2": adhyastaSwiper3B },
    { "divisi": "sarwaga", "foto1": sarwagaSwiper1A, "foto2": sarwagaSwiper1B },
    { "divisi": "sarwaga", "foto1": sarwagaSwiper2A, "foto2": sarwagaSwiper2B },
];

    const listAnggotaWiskira = [
    { "first": "FARION", "last": "TEKKRY", "jabatan": "Koordinator", "foto1": wiskiraAnggota1A, "foto2": wiskiraAnggota1B },
    { "first": "JEZREEL", "last": "KOSASIH", "jabatan": "Koordinator", "foto1": wiskiraAnggota2A, "foto2": wiskiraAnggota2B },
    { "first": "AILEE", "last": "VICH", "jabatan": "Anggota", "foto1": wiskiraAnggota3A, "foto2": wiskiraAnggota3B },
    { "first": "ALDRIK", "last": "CIAPUTRA", "jabatan": "Anggota", "foto1": wiskiraAnggota4A, "foto2": wiskiraAnggota4B },
    { "first": "ARLYNANDHITA", "last": "FELISYA", "jabatan": "Anggota", "foto1": wiskiraAnggota5A, "foto2": wiskiraAnggota5B },
    { "first": "AXEL", "last": "FERDINAND", "jabatan": "Anggota", "foto1": wiskiraAnggota6A, "foto2": wiskiraAnggota6B },
    { "first": "DAFFA", "last": "AKBARI", "jabatan": "Anggota", "foto1": wiskiraAnggota7A, "foto2": wiskiraAnggota7B },
    { "first": "HANS", "last": "PHILEMON", "jabatan": "Anggota", "foto1": wiskiraAnggota8A, "foto2": wiskiraAnggota8B },
    { "first": "JACINTHA", "last": "CORDELIE", "jabatan": "Anggota", "foto1": wiskiraAnggota9A, "foto2": wiskiraAnggota9B },
    { "first": "JOSHUA", "last": "HOTAMA", "jabatan": "Anggota", "foto1": wiskiraAnggota10A, "foto2": wiskiraAnggota10B },
    { "first": "KOONG", "last": "HIAP", "jabatan": "Anggota", "foto1": wiskiraAnggota11A, "foto2": wiskiraAnggota11B },
];

const listAnggotaPrabangkara = [
    { "first": "GIOVANN", "last": "BYANCA", "jabatan": "Koordinator", "foto1": prabangkaraAnggota1A, "foto2": prabangkaraAnggota1B },
    { "first": "STEVAN", "last": "ANTONIUS", "jabatan": "Koordinator", "foto1": prabangkaraAnggota2A, "foto2": prabangkaraAnggota2B },
    { "first": "ABDUL", "last": "KHALIQ", "jabatan": "Anggota", "foto1": prabangkaraAnggota3A, "foto2": prabangkaraAnggota3B },
    { "first": "", "last": "ALEXANDER", "jabatan": "Anggota", "foto1": prabangkaraAnggota4A, "foto2": prabangkaraAnggota4B },
    { "first": "ANDREW", "last": "SU", "jabatan": "Anggota", "foto1": prabangkaraAnggota5A, "foto2": prabangkaraAnggota5B },
    { "first": "AZKIA", "last": "AINA", "jabatan": "Anggota", "foto1": prabangkaraAnggota6A, "foto2": prabangkaraAnggota6B },
    { "first": "", "last": "BERNICE", "jabatan": "Anggota", "foto1": prabangkaraAnggota7A, "foto2": prabangkaraAnggota7B },
    { "first": "DEVIN", "last": "EDSEL", "jabatan": "Anggota", "foto1": prabangkaraAnggota8A, "foto2": prabangkaraAnggota8B },
    { "first": "FAUZAN", "last": "ABDULLAH", "jabatan": "Anggota", "foto1": prabangkaraAnggota9A, "foto2": prabangkaraAnggota9B },
    { "first": "JOHAN", "last": "FELIX", "jabatan": "Anggota", "foto1": prabangkaraAnggota10A, "foto2": prabangkaraAnggota10B },
    { "first": "JOSE", "last": "ANDREAS", "jabatan": "Anggota", "foto1": prabangkaraAnggota11A, "foto2": prabangkaraAnggota11B },
    { "first": "KELVIN", "last": "KURNIAWAN", "jabatan": "Anggota", "foto1": prabangkaraAnggota12A, "foto2": prabangkaraAnggota12B },
    { "first": "KENZIE", "last": "ANDHIKA", "jabatan": "Anggota", "foto1": prabangkaraAnggota13A, "foto2": prabangkaraAnggota13B },
    { "first": "", "last": "MARCELLINO", "jabatan": "Anggota", "foto1": prabangkaraAnggota14A, "foto2": prabangkaraAnggota14B },
    { "first": "MARCO", "last": "SAPUTRA", "jabatan": "Anggota", "foto1": prabangkaraAnggota15A, "foto2": prabangkaraAnggota15B },
    { "first": "MARGARETH", "last": "RITONGA", "jabatan": "Anggota", "foto1": prabangkaraAnggota16A, "foto2": prabangkaraAnggota16B },
    { "first": "MUTIARA", "last": "CINTA", "jabatan": "Anggota", "foto1": prabangkaraAnggota17A, "foto2": prabangkaraAnggota17B },
    { "first": "SAKTI", "last": "YUDHA", "jabatan": "Anggota", "foto1": prabangkaraAnggota18A, "foto2": prabangkaraAnggota18B },
    { "first": "RAVALEN", "last": "VIRGINIA", "jabatan": "Anggota", "foto1": prabangkaraAnggota19A, "foto2": prabangkaraAnggota19B },
    { "first": "THIRZA", "last": "ABIGAIL", "jabatan": "Anggota", "foto1": prabangkaraAnggota20A, "foto2": prabangkaraAnggota20B },
];

    const [swiperAnggota, setSwiperAnggota] = useState(false);
    const [swiper, setSwiper] = useState(false);

    // GANTI CARD WISKIRA ATAU PRABANGKARA
    useEffect(() => {
        const intervalSwiperAnggota = setInterval(() => {
            setSwiperAnggota(!swiperAnggota);
        }, 2000);

        return () => {
            clearInterval(intervalSwiperAnggota);
        };
    }, [swiperAnggota]);

    // GANTI IMAGE SWIPER
    useEffect(() => {
        const intervalSwiper = setInterval(() => {
            setSwiper(!swiper);
        }, 5000);
      
        return () => {
            clearInterval(intervalSwiper);
        };
    }, [swiper]);

    return (
        <>
            <div className="FotoDivisi">
    <TopInfo />
    {listDivisi.map((item, index) => {
        if (item.divisi === domain) {
            return (
                <HeadingLogo
                    key={index}
                    lagu={dapatkanAset(`${domain}/Yelyel.mp3`)}
                    img={dapatkanAset(`${domain}/Logo.webp`)}
                    nama={item.nama}
                    job={item.job}
                    style={item.style}
                />
            )
        }
        return null;
    })}
    {domain === "wiskira" ? (
        <div className="box-swiper-anggota">
            <Swiper
                slidesPerView={4}
                centeredSlides={false}
                loop={true}
                grabCursor={true}
                keyboard={{ enabled: true }}
                breakpoints={{
                    810: { slidesPerView: 4, slidesPerGroup: 4 },
                    432: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 12 },
                    200: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 8 },
                }}
                navigation={true}
                pagination={{
                    el: '.swiper-pagination-wiskira',
                    clickable: true,
                }}
                spaceBetween={16}
                modules={[Keyboard, Navigation, Pagination]}
                className="mySwiper"
            >
                {listAnggotaWiskira.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className="background"></div>
                        <img className="logo" src={logo} alt="" />
                        <img className="kupu-kupu" src={kupu} alt="" />
                        <div className="shadow"></div>
                        {swiperAnggota === false ? (
                            <img className="foto" src={item.foto1} alt="" />
                        ) : swiperAnggota === true ? (
                            <img className="foto" src={item.foto2} alt="" />
                        ) : null}
                        <p className="first">{item.first}</p>
                        <p className="last">{item.last}</p>
                        <p className="job">{item.jabatan}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="swiper-pagination-wiskira" slot="pagination"></div>
        </div>
    ) : domain === "prabangkara" ? (
        <div className="box-swiper-anggota">
            <Swiper
                slidesPerView={4}
                centeredSlides={false}
                loop={true}
                grabCursor={true}
                keyboard={{ enabled: true }}
                breakpoints={{
                    810: { slidesPerView: 4, slidesPerGroup: 4 },
                    432: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 12 },
                    200: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 8 },
                }}
                navigation={true}
                pagination={{
                    el: '.swiper-pagination-wiskira',
                    clickable: true,
                }}
                spaceBetween={16}
                modules={[Keyboard, Navigation, Pagination]}
                className="mySwiper"
            >
                {listAnggotaPrabangkara.map((item, index) => {
                    let satuKata = item.first === "";
                    return (
                        <SwiperSlide key={index}>
                            <div className="background-prabangkara"></div>
                            <div className="shadow-prabangkara"></div>
                            <img className="supergrafis" src={supergrafis} alt="" />
                            {swiperAnggota === false ? (
                                <img className="foto" src={item.foto1} alt="" />
                            ) : swiperAnggota === true ? (
                                <img className="foto" src={item.foto2} alt="" />
                            ) : null}
                            <p className="first">{item.first}</p>
                            {satuKata ? (
                                <p className="last" id="last">{item.last}</p>
                            ) : (
                                <p className="last">{item.last}</p>
                            )}
                            <p className="job">{item.jabatan}</p>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            <div className="swiper-pagination-wiskira" slot="pagination"></div>
        </div>
    ) : null}
    {(domain === "wiskira" || domain === "prabangkara") && (
        <p className="textFotoDivisi">Foto Divisi</p>
    )}
    {domain === "arsa" || domain === "adhyasta" || domain === "sarwaga" ? (
        <div className="box-swiper">
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                navigation={{
                    prevEl: prevButtonRow.current,
                    nextEl: nextButtonRow.current,
                }}
                modules={[Pagination, Navigation]}
                allowTouchMove={false}
                className="mySwiper"
            >
                {listFotoSwiper.map((item, index) => {
                    if (item.divisi === domain) {
                        return (
                            <SwiperSlide key={index}>
                                {swiper === false ? (
                                    <img className="foto" src={item.foto1} alt="" />
                                ) : swiper === true ? (
                                    <img className="foto" src={item.foto2} alt="" />
                                ) : null}
                                <div className="shadow-top"></div>
                                <div className="shadow-bottom"></div>
                            </SwiperSlide>
                        )
                    }
                    return null;
                })}
                <div ref={prevButtonRow} onClick={prevSlide} className="swiper-button-prev"></div>
                <div ref={nextButtonRow} onClick={nextSlide} className="swiper-button-next"></div>
            </Swiper>
        </div>
    ) : (
        <div className="box-swiper">
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                navigation={{
                    prevEl: prevButton.current,
                    nextEl: nextButton.current,
                }}
                modules={[Pagination, Navigation]}
                allowTouchMove={false}
                className="mySwiper"
            >
                {[1, 2, 3].map((num) => (
                    <SwiperSlide key={num}>
                        <img className="foto" src={dapatkanAset(`${domain}/Swiper${num}.jpg`)} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-bottom"></div>
                    </SwiperSlide>
                ))}
                <div ref={prevButton} onClick={prevSlide} className="swiper-button-prev"></div>
                <div ref={nextButton} onClick={nextSlide} className="swiper-button-next"></div>
            </Swiper>
        </div>
    )}
    {domain === "bimantara" ? (
        <div className="box-anggota">
            <div className="box"><p className="jabatan">SUPERVISI</p><p className="nama">Sherly</p></div>
            <div className="box"><p className="jabatan">KETUA</p><p className="nama">Reynaldy Michael Yacob</p></div>
            <div className="box"><p className="jabatan">WAKIL KETUA</p><p className="nama">Irene Zanetha Halim</p></div>
            <div className="box"><p className="jabatan">SEKRETARIS 1</p><p className="nama">Kenza Tanika</p></div>
            <div className="box"><p className="jabatan">SEKRETARIS 2</p><p className="nama">Steven Feliciano Wiggins</p></div>
            <div className="box"><p className="jabatan">BENDAHARA</p><p className="nama">Faustine Ilone Hadinata</p></div>
        </div>
    ) : domain === "arsa" || domain === "adhyasta" || domain === "sarwaga" ? (
        <div className="box-anggota-lain">
            {listAnggotaRow.map((item, index) => {
                if (item.divisi === domain) {
                    return (
                        <div key={index} className="box-koor" style={{ background: item.color }}>
                            <p className="jabatan">KOORDINATOR</p>
                            <p className="nama">{item.koor} </p>
                        </div>
                    );
                }
                return null;
            })}
            {listAnggotaRow.map((item, index) => {
                if (item.divisi === domain) {
                    return (
                        <div key={index} className="box-anggota" style={{ borderColor: item.color, background: item.lightColor }}>
                            <p className="jabatan" style={{ color: item.color }}>ANGGOTA</p>
                            {item.anggota.map((isiItems, idx) => {
                                if (idx === slide) {
                                    return <p key={idx} className="nama">{isiItems.nama}</p>;
                                }
                                return null;
                            })}
                        </div>
                    );
                }
                return null;
            })}
        </div>
    ) : domain === "wiskira" || domain === "prabangkara" ? (
        <div></div>
    ) : (
        <div className="box-anggota-lain">
            {listAnggota.map((item, index) => {
                if (item.divisi === domain) {
                    return (
                        <div key={index} className="box-koor" style={{ background: item.color }}>
                            <p className="jabatan">KOORDINATOR</p>
                            <p className="nama">{item.koor} </p>
                        </div>
                    );
                }
                return null;
            })}
            {listAnggota.map((item, index) => {
                if (item.divisi === domain) {
                    return (
                        <div key={index} className="box-anggota" style={{ borderColor: item.color, background: item.lightColor }}>
                            <p className="jabatan" style={{ color: item.color }}>ANGGOTA</p>
                            <p className="nama">{item.anggota} </p>
                        </div>
                    );
                }
                return null;
            })}
        </div>
    )}
    <div className="dokumentasi">
        <p className="judul">Dokumentasi Divisi</p>
        <div className="konten-foto">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => {
                const urlGambar = dapatkanAset(`${domain}/Dokumentasi/${num}.jpeg`);
                return (
                    <img 
                        key={num}
                        className="foto" 
                        onClick={() => openModal(urlGambar)} 
                        src={urlGambar} 
                        alt="" 
                    />
                );
            })}
        </div>
    </div>
</div>

            {modal ?
                <div ref={Modal} id="comingsoon" className="comingsoon">
                    <div className="modal-content">
                        <img className="foto" src={foto} alt="" />
                    </div>
                </div>
                : null}
        </>
    )
}

export { FotoDivisi }